import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Carousel } from 'react-responsive-carousel'; // requires a loader
import React, { ReactNode } from 'react';

type TImage = {
    url: any;
    id: number;
    slide: number;
};

type Props = {
    images?: TImage[];
    onCompleteSlide: (idx: number, item: ReactNode) => void;
    solved: TImage[];
};
export default function ZdarFairyTaleCharactersCarousel({ images, onCompleteSlide, solved }: Props) {
    const getClassName = (i: TImage) => {
        return solved.find((s) => s.slide === i.slide) ? 'carousel-solved' : 'carousel-unsolved';
    };

    return (
        <React.Fragment>
            {images && images.length > 0 && (
                <Carousel
                    showThumbs={false}
                    showStatus={false}
                    onChange={onCompleteSlide}
                    infiniteLoop
                    autoPlay={false}
                    showIndicators={false}
                >
                    {images?.map((f, i) => {
                        return (
                            <div key={i}>
                                <img className={getClassName(f)} src={f.url} alt="image" />
                            </div>
                        );
                    })}
                </Carousel>
            )}
        </React.Fragment>
    );
}
